import * as yup from "yup";

export default yup.object().shape({
    name: yup.string().required().label("Name"),
    is_active: yup.boolean().default(true).label("Active"),
    record_sync_stt: yup.boolean().default(false).notRequired().label("Record Sync STT"),
    timeformat: yup
        .mixed()
        .oneOf(["12-hour", "24-hour"])
        .default("12-hour")
        .required()
        .label("Time Format"),
    provider: yup
        .mixed()
        .oneOf(["google", "watson"])
        .notRequired()
        .default("google")
        .label("STT Provider"),
    instance_id: yup.number().required().label("Instance"),
    content_generator: yup.boolean().default(false).notRequired().label("AI Summary Enabled"),
    sso_configured: yup.boolean().default(false).notRequired().label("Open in a new window"),
    new_platform: yup.boolean().default(false).notRequired().label("Rollio v2 Enabled"),
    aws_kms: yup.string().notRequired().label("AWS Encryption Key"),
    organization_id: yup.number().label("Organization ID"),
});
